<template>
  <div class="row">

    <div class="col-12">
      <p class="lead">The city profiles provide summaries of the future readiness performances of all 102 cities included in the CFRI report. Each city profile includes data on key indicators, future readiness ranking, breakdown of performances in each of the pillars and sub-pillars of the CFRI model, and comparative performances against global averages.</p>
    </div>

    <div class="col-12 my-3">
      <b-form-select size="md" v-model="selected" :options="options"></b-form-select>
    </div>

    <city-profile :selected-city="selected"></city-profile>

  </div>
</template>

<script>
import citiesData from '../data_2025/cities.json';
import CityProfile from "../views-2025/components-2025/CityProfile";

export default {
  name: "CityProfiles",
  components: {CityProfile},
  data() {
    return {
      selected: 'san-francisco',
      options: []
    }
  },
  created() {
    this.generateCityOptions()
    this.fetchCity()
  },
  methods: {
    generateCityOptions() {
      this.options = Object.keys(citiesData)
        .map(slug => ({
          text: `${citiesData[slug].city}, ${citiesData[slug].country}`,
          value: slug
        }))
        .sort((a, b) => a.text.localeCompare(b.text))
    },
    fetchCity() {
      if (this.$route.query.city) {
        this.selected = this.$route.query.city
      }
    }
  },
  watch: {
    selected() {
      // Update route query when city changes
      const query = { ...this.$route.query, city: this.selected }
      this.$router.replace({ query })
    }
  }
}
</script>

<style>

.country-buttons .form-group {
  width: 100%;
}

.btn-group.special {
  display: flex !important;
}

.special .btn {
  flex: 1 !important;
}

.width-100 {
  width: 100%;
}

</style>
